import { render, staticRenderFns } from "./ExtremeEItem.vue?vue&type=template&id=1a29b9c8&scoped=true&"
import script from "./ExtremeEItem.vue?vue&type=script&lang=js&"
export * from "./ExtremeEItem.vue?vue&type=script&lang=js&"
import style0 from "./ExtremeEItem.vue?vue&type=style&index=0&id=1a29b9c8&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1a29b9c8",
  null
  
)

export default component.exports